import React from "react";
import {
  MDBBtn,
  MDBCard,
  MDBCardBody,
  MDBCardHeader,
  MDBCardTitle,
  MDBCol,
  MDBRow,
  MDBTypography,
  MDBBadge,
} from "mdb-react-ui-kit";

const BORDER_COLORS = ["primary", "warning", "info"];

const RorOption = ({ option, onSelectRor, borderColor, isUserSelected }) => {
  const allIdentifiers = [
    ...(option?.acronyms || []),
    ...(option?.aliases || []),
    ...(option?.labels || [])
  ].filter(item => typeof item === 'string' && item.trim() !== '');

  const parentInfo = option?.parents && option.parents.length > 0
    ? `(child of ${option.parents.map(p => p.name).join(", ")})`
    : "";

  const location = [];
  if (option?.city) location.push(option.city);
  if (option?.country) location.push(option.country);
  const locationText = location.length > 0 ? location.join(", ") : null;

  const cardBorder = isUserSelected ? "success" : borderColor;
  const cardStyle = isUserSelected
    ? { backgroundColor: "#e6f9ed", borderWidth: 2, borderStyle: 'solid' }
    : {};

  return (
    <MDBCard border={cardBorder} style={cardStyle}>
      <MDBCardBody className="text-start">
        <MDBRow>
          <MDBCol lg={10} md={10}>
            <MDBTypography variant="h5" className="fw-bolder">
              {option?.ror_name}
              {locationText && `, ${locationText}`}
              {isUserSelected && (
                <MDBBadge color="success" pill className="ms-2 align-middle">
                  Current selection
                </MDBBadge>
              )}
            </MDBTypography>
            {allIdentifiers.length > 0 && (
              <MDBTypography variant="body2" className="text-muted">
                {allIdentifiers.join(", ")}
              </MDBTypography>
            )}
            <div className="mb-2">
              <a
                href={option?.ror_id}
                target="_blank"
                rel="noreferrer"
                aria-label={`Link to ${option?.ror_name}`}
                className="text-decoration-none"
              >
                {option?.ror_id}
              </a>
              {parentInfo && (
                <MDBTypography variant="body2" className="text-muted d-inline ms-1">
                  {parentInfo}
                </MDBTypography>
              )}
            </div>
          </MDBCol>
          <MDBCol>
            <div
              className="d-flex align-items-center justify-content-end"
              style={{ height: "100%" }}
            >
              <MDBBtn
                color={cardBorder}
                onClick={() => onSelectRor(option.ror_id)}
              >
                Select
              </MDBBtn>
            </div>
          </MDBCol>
        </MDBRow>
      </MDBCardBody>
    </MDBCard>
  );
};

export const ModerateSelectRorCard = ({ task, onSelectRor }) => {
  const userSelectedRorId = task.data?.user_selection?.selected_ror_id;
  const isNoneSelected = userSelectedRorId === null;
  
  const noneCardBorder = isNoneSelected ? "success" : "danger";
  const noneCardStyle = isNoneSelected
    ? { backgroundColor: "#e6f9ed", borderWidth: 2, borderStyle: 'solid' }
    : {};
    
  return (
    <MDBCard className="mb-5">
      <MDBCardHeader>
        <MDBCardTitle className="lead mt-1">
          Moderate: Select the matching ROR record
        </MDBCardTitle>
      </MDBCardHeader>
      <MDBCardBody>
        <div className="text-start mb-4">
          <MDBTypography variant="h6" className="text-muted mb-2">
            Affiliation text:
          </MDBTypography>
          <MDBTypography variant="h5" className="fw-bolder">
            {task.data?.affiliation}
          </MDBTypography>
        </div>
        <MDBRow className="g-3">
          {task.data?.options?.map((option, index) => (
            <RorOption
              key={option.ror_id}
              option={option}
              onSelectRor={onSelectRor}
              borderColor={BORDER_COLORS[index % BORDER_COLORS.length]}
              isUserSelected={option.ror_id === userSelectedRorId}
            />
          ))}
          <MDBCard border={noneCardBorder} style={noneCardStyle}>
            <MDBCardBody className="text-start">
              <MDBRow>
                <MDBCol md={9}>
                  <MDBTypography variant="h5" className="fw-bolder">
                    None of these options
                    {isNoneSelected && (
                      <MDBBadge color="success" pill className="ms-2 align-middle">
                        Current selection
                      </MDBBadge>
                    )}
                  </MDBTypography>
                  <MDBTypography variant="body2" className="text-muted">
                    Select this if none of the above organizations match the affiliation
                  </MDBTypography>
                </MDBCol>
                <MDBCol>
                  <div
                    className="d-flex align-items-center justify-content-end"
                    style={{ height: "100%" }}
                  >
                    <MDBBtn color={noneCardBorder} onClick={() => onSelectRor(null)}>
                      Select
                    </MDBBtn>
                  </div>
                </MDBCol>
              </MDBRow>
            </MDBCardBody>
          </MDBCard>
        </MDBRow>
      </MDBCardBody>
    </MDBCard>
  );
}; 